import { BiSearch } from "react-icons/bi";
import classes from "./SearchInput.module.css";
import { mergeClass } from "../../../resources/utils/helper";
import { Input } from "../../atoms/Input/Input";

export default function SearchInput({
  value = "",
  setValue = () => {},
  placeholder = "Search here...",
  customStyle = {},
  inputStyle = {},
  className = "",
  inputDivClass,
  inputClass,
  leftIconStyle,
}) {
  return (
    <Input
      type="text"
      value={value}
      setValue={setValue}
      placeholder={placeholder}
      leftIcon={<BiSearch style={{ fontSize: "18px", ...leftIconStyle }} />}
      customStyle={{
        height: "50px",
        width: "100%",
        display: "flex",
        alignItems: "center",
        border: "1px solid var(--gray-color-v2)",
        borderRadius: "8px",
        backgroundColor: "var(--white-color-v1)",
        padding: "0 20px",
        ...customStyle,
      }}
      inputStyle={{
        width: "100%",
        fontSize: "16px",
        fontFamily: "var(--poppins)",
        border: "none",
        flex: 1,
        color: "var(--gray-color-v2)",
        ...inputStyle,
      }}
      inputClass={mergeClass(inputClass, classes.inputClass)}
      // inputContainer={mergeClass("w-full xl:w-[400px]", inputDivClass)}
    />
  );
}
